import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  async getSchedules () {
    return axios.get(endpoints.schedules + '?is_template=false').then((response) => {
      return response.data
    })
  },
  async getScheduleTemplates () {
    return axios.get(endpoints.schedules + '?is_template=true').then((response) => {
      return response.data
    })
  },
  async createScheduleTemplate (obj) {
    return axios.post(endpoints.schedules, obj).then((response) => {
      return response.data
    })
  },
  async getScheduleItemsData (from, to) {
    // Returns all routes, schedule items, work orders, and unscheduled, from API in one call
    // Filtered based on date range (useful for month/week/day)
    return axios.get(endpoints.scheduleItems + 'schedule_data/?from=' + from + '&to=' + to).then((response) => {
      return response.data
    })
  },
  async getTemplateScheduleItemsData (scheduleID) {
    // Returns all routes, schedule items, work orders, and unscheduled, from API in one call
    return axios.get(endpoints.scheduleItems + 'template_data/?id=' + scheduleID).then((response) => {
      return response.data
    })
  },
  async getScheduleObj (scheduleID) {
    return axios.get(endpoints.schedules + scheduleID).then((response) => {
      return response.data
    })
  },
  async updateSchedule (obj) {
    return axios.patch(endpoints.schedules + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async getUnscheduledWOs (scheduleID) {
    // This must return all WOs that have not had a RouteItem pointing to them. This could be tricky.
    return axios.get(endpoints.routes + 'unscheduled/?schedule=' + scheduleID ).then((response) => {
      return response.data
    })
  },
  async getRoutesForDateRange (from, to, scheduleID) {
    return axios.get(endpoints.routes + '?date__gte=' + from + '&date__lte=' + to + '&schedule=' + scheduleID ).then((response) => {
      return response.data
    })
  },
  async updateRouteWos (routeUpdateArray) {
    return axios.post(endpoints.routes + 'reschedule/', routeUpdateArray).then((response) => {
      return response.data
    })
  },
  async createRoute (obj) {
    return axios.post(endpoints.routes, obj).then((response) => {
      return response.data
    })
  },
  async getRoute (routeID) {
    return axios.get(endpoints.routes + routeID + '/').then((response) => {
      return response.data
    })
  },
  async updateRoute (obj) {
    return axios.patch(endpoints.routes + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async deleteRoute (obj) {
    return axios.delete(endpoints.routes + obj.id + '/').then((response) => {
      return response.data
    })
  },
  async getRouteWOs (routeID) {
    return axios.get(endpoints.wos + '?route=' + routeID).then((response) => {
      return response.data
    })
  },
  async getSnowRouteWOs (routeID) {
    return axios.get(endpoints.wos + 'snow_route/?route=' + routeID).then((response) => {
      return response.data
    })
  },
  async getScheduleWOs (scheduleID) {
    // Mainly used for schedule templates
    return axios.get(endpoints.wos + '?schedule=' + scheduleID).then((response) => {
      return response.data
    })
  },
  async getLeads () {
    // Only returns profiles that have been flagged as being able to be a lead
    return axios.get(endpoints.profiles + '?can_be_lead=true').then((response) => {
      return _.orderBy(response.data, 'name_display')
    })
  },
  async assignRoutes (obj) {
    return axios.post(endpoints.assignRoutes, obj).then((response) => {
      return response.data
    })
  },
  async getCrewVisitsForWO (obj) {
    return axios.get(endpoints.crewVisits + '?work_order=' + obj.id).then((response) => {
      return response.data
    })
  },

  async getEvents (from = null, to = null) {
    let query = ''
    // MJ - I don't know how to structure the filters (but this call needs to be schedule specific maybe?)
    if (from) {
      query = '?date__gte=' + from
      if (to) {
        query = query + '&date__lte=' + to
      }
    }
    return axios.get(endpoints.events + query).then((response) => {
      return response.data
    })
  },
  async getEvent (eventID) {
    return axios.get(endpoints.events + eventID + '/').then((response) => {
      return response.data
    })
  },
  async createEvent (event) {
    return axios.post(endpoints.events, event).then((response) => {
      return response.data
    })
  },
  async deleteEvent (event) {
    await axios.delete(endpoints.events + event.id + '/').then((response) => {
      return response.data
    })
  },
  async updateEvent (event) {
    return axios.patch(endpoints.events + event.id + '/', event).then((response) => {
      return response.data
    })
  },

}
